import React from 'react';
import { dateFormatters } from '@insurancemenu/imenu-components-lib/dist/helpers';
import { GROUP_INFO_BLOB_TEST_ID } from 'components/common/enrollment/constants';
import { BlobContainerStyled, BlobTextStyled, BlobTextWrapperStyled, BlobTitleStyled } from './styles';

interface GroupInfoBlobProps {
  groupName: string;
  effectiveDate: string;
}

const GroupInfoBlob: React.FC<GroupInfoBlobProps> = ({ groupName, effectiveDate }) => {
  return (
    <BlobContainerStyled data-test-id={GROUP_INFO_BLOB_TEST_ID}>
      <BlobTextWrapperStyled>
        <BlobTitleStyled>Group Name :</BlobTitleStyled>
        <BlobTextStyled>{groupName}</BlobTextStyled>
      </BlobTextWrapperStyled>
      <BlobTextWrapperStyled>
        <BlobTitleStyled>Effective Date :</BlobTitleStyled>
        <BlobTextStyled>{dateFormatters.normDateToShortAmericanDate(effectiveDate)}</BlobTextStyled>
      </BlobTextWrapperStyled>
    </BlobContainerStyled>
  );
};

export default GroupInfoBlob;
